import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full border-b border-background-200 bg-background-100/60">
      <ol className="flex w-full flex-wrap items-center gap-x-2 gap-y-1 px-4 py-3 text-xs text-foreground-500 md:px-8 md:text-sm">
        <li className="flex items-center gap-2">
          <Link to="/" className="cursor-pointer transition-colors hover:text-primary-700">
            首页
          </Link>
        </li>
        {items.map((item) => (
          <li key={item.label} className="flex items-center gap-2">
            <span className="flex h-3.5 w-3.5 items-center justify-center text-foreground-400">
              <i className="ri-arrow-right-s-line text-base leading-none" aria-hidden="true" />
            </span>
            {item.to ? (
              <Link to={item.to} className="cursor-pointer transition-colors hover:text-primary-700">
                {item.label}
              </Link>
            ) : (
              <span className="max-w-[240px] truncate font-medium text-foreground-800 sm:max-w-none">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}